import { PawPrint, MessageCircle, MapPin } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import { waLink, WHATSAPP_BUSINESS, WHATSAPP_PERSONAL } from "@/lib/api";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid={FOOTER.section}
      className="bg-[#0F2520] text-[#F9F8F6] pt-20 pb-10 px-6 md:px-10"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <PawPrint className="w-6 h-6 text-[#F4D06F]" />
            <span className="font-display text-xl font-bold">Raijada Kennel</span>
          </div>
          <p className="font-light text-[#F9F8F6]/60 leading-relaxed max-w-xs">
            KCI Registered &amp; Govt Certified breeder of authentic Golden Retrievers, with lifetime BVSc
            veterinary support.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#F4D06F] mb-4">Talk to Pushkar Singh</p>
          <a
            data-testid={FOOTER.whatsappBusiness}
            href={waLink(WHATSAPP_BUSINESS)}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 mb-3 font-light hover:text-[#F4D06F] transition-colors"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp (Business): +91 78697 27989
          </a>
          <a
            data-testid={FOOTER.whatsappPersonal}
            href={waLink(WHATSAPP_PERSONAL)}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 font-light hover:text-[#F4D06F] transition-colors"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp: +91 93407 77640
          </a>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#F4D06F] mb-4">Visit Us</p>
          <p data-testid={FOOTER.address} className="flex items-start gap-2 font-light text-[#F9F8F6]/60 leading-relaxed max-w-xs">
            <MapPin className="w-4 h-4 mt-1 shrink-0 text-[#F4D06F]" />
            Pushkar Singh, Village &amp; Post Bhandiwar, Tehsil Bara, District Prayagraj, Uttar Pradesh, PIN 212108
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#F4D06F] mb-4">Certifications</p>
          <p className="font-light text-[#F9F8F6]/60">KCI Registered · Government Certified Breeder</p>
          <p className="font-light text-[#F9F8F6]/60 mt-2">Lifetime medical support by BVSc Veterinarian</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-sm text-[#F9F8F6]/40 flex flex-col md:flex-row justify-between gap-2">
        <p>© {new Date().getFullYear()} Raijada Dog Kennel. All rights reserved.</p>
        <a href="/admin/login" className="hover:text-[#F4D06F] transition-colors">Admin</a>
      </div>
    </footer>
  );
};
